// Telugu translations
export const te: Record<string, string> = {
  'menu.dashboard': 'డాష్‌బోర్డ్',
  'menu.orderNew': 'ఉత్పత్తి నమోదు',
  'menu.customers': 'కస్టమర్లు',
  'menu.products': 'ఉత్పత్తులు',
  'menu.users': 'వినియోగదారులు',
  'menu.settings': 'సెట్టింగ్‌లు',
  'menu.logout': 'లాగ్ అవుట్',
  'dashboard.title': 'డాష్‌బోర్డ్',
  'dashboard.todaySales': 'నేటి అమ్మకాలు',
  'dashboard.totalOrders': 'మొత్తం ఆర్డర్లు',
  'dashboard.newOrder': 'కొత్త ఆర్డర్',
  'dashboard.newCustomer': 'కొత్త కస్టమర్',
  'order.title': 'కొత్త ఆర్డర్',
  'order.customer': 'కస్టమర్',
  'order.products': 'ఉత్పత్తులు',
  'order.quantity': 'పరిమాణం',
  'order.price': 'ధర',
  'order.total': 'మొత్తం',
  'order.payment': 'చెల్లింపు',
  'order.cash': 'నగదు',
  'order.card': 'కార్డ్',
  'users.title': 'వినియోగదారులు',
  'users.name': 'పేరు',
  'users.email': 'ఇమెయిల్',
  'users.role': 'పాత్ర',
  'users.edit': 'సవరించు',
  'users.delete': 'తొలగించు',
  'common.yes': 'అవును',
  'common.no': 'కాదు',
  'common.cancel': 'రద్దు',
  'common.save': 'సేవ్',
  'common.search': 'వెతకండి',
  'common.loading': 'లోడ్ అవుతోంది...',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'లాగిన్',
  'login.enterPin': 'పిన్ నమోదు చేయండి',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'నమోదు',
  'signup.createAccount': 'ఖాతా సృష్టించండి',
  'signup.email': 'ఇమెయిల్',
  'signup.phone': 'ఫోన్',
  'menu.reportsAndAccounting': 'నివేదికలు & అకౌంటింగ్',
  'menu.systemAndCommunication': 'సిస్టమ్ & కమ్యూనికేషన్',
};
